import { render, staticRenderFns } from "./EspeciesForm.vue?vue&type=template&id=2c7f052a&"
import script from "./EspeciesForm.vue?vue&type=script&lang=js&"
export * from "./EspeciesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports